<template>
  <div class="news">
   <indexHd ref="checkLogin"/>
    <div class="content">
       <div class="commonBg">
                <div class="wrapper">
                    <div class="formBox">
						<div class="form" >
							<div class="comtit">
								<h5>欢迎登录</h5>
							</div>
							<div class="inptBox">
								<label>手机号</label>
								<input v-model="phone" class="inpt" @keyup.enter="checkLogin" type="tel" placeholder="请输入手机号码">
							</div>
							<div class="inptBox">
								<label>密码</label>
								<input v-model="password" class="inpt"  @keyup.enter="checkLogin" :type="pwdType" placeholder="请输入密码">
								<img class="isOpen" :src="see?noeyes:eyes" @click="changeType()"/>
							</div>
							<div class="remberPwd">
								<label><input class="check" type="checkbox" v-model="checked" />记住用户名</label>
								<!-- <span class="forget" @click="forgetPwd">忘记密码？</span> -->
							</div>
							<div class="btnMod">
								<button class="btn"  @click="checkLogin">登录</button>
							</div>
							<div class="toRegs">
								<!-- <div class="megLogin">短信验证码登录</div> -->
								<div class="gotoRegs">没有账号？<router-link class="blue" :to="{path:'/Register'}">立即注册</router-link></div>
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
	<foot />
  </div>
</template>
<script>

import eyes from '@/assets/img/eyes.png'
import noeyes from '@/assets/img/noeyes.png'
import indexHd from '@/components/indexHd.vue'
import foot from '@/components/foot.vue'
// import Cookies from 'js-cookie'
export default {
  name: 'Login',
  components: {
    foot,
    indexHd
  },
  data () {
    return {
      loading:true,
      eyes,
      noeyes,
      phone: '',
      password: '',
      name: '',
      token: '',
      see: '',
      checked: false,
      pwdType: 'password', 
      redirctUrl:'',
      member:{}
    }
  },
  created () {
    this.redirctUrl=this.$route.query.redirect
    this.phone=this.getCookie("username")
    this.checked=this.phone?true:false
		localStorage.removeItem('token')
  },
  mounted () {
    this.$refs.checkLogin.loginNo = true
    this.$refs.checkLogin.loginYes = false
  },
  methods: {

    changeType () {
      this.pwdType = this.pwdType === 'password' ? 'text' : 'password'
      this.see = !this.see
    },
    checkLogin () { // 登录的方法
      const parmas = { phone: this.phone, password: this.password }
      if (this.phone === '' || this.password === '') {
          this.$alert('手机号码和密码不能为空')
          return
        }
      this.$api.getMemberLogin(parmas).then(response => {
        if (response.code === 500 || response.code === 401) {
          this.$alert(response.msg)
          return
        }
        this.token = response.token
        this.name = response.member.name
        this.member = JSON.stringify(response.member)
        // 判断复选框是否被勾选 勾选则调用配置cookie方法
        if (this.checked === true) {
          this.setCookie("username",this.phone,1000*60*24*7)// 设置七天过期
        }    
        localStorage.setItem('token', this.token)
        localStorage.setItem('name', this.name)
        localStorage.setItem('member',this.member)
        if(this.redirctUrl){
          this.$router.push({ path: this.redirctUrl })
        }else{
           // 跳转首页
          this.$router.push({ path: '/' })
        }
       
      })
    }
  }

}
</script>
<style scoped lang="scss">

</style>
